<div id="wrapper">
  <app-navbar></app-navbar>

  <app-sidebar></app-sidebar>

  <div class="content-page">
    <div class="content">
      <div class="content-pane">
        <div class="container-fluid">
          <div class="breadcrumb">
            <span class="breadcrumb-item">
              <a href="javascript:void(0)">PayEXAP</a>
            </span>
            <span class="px-2"><i class="ri-arrow-right-s-line"></i></span>
            <span class="breadcrumb-item" aria-current="page">
              <a routerLink="/invoices">Invoices</a>
            </span>
            <span class="px-2"><i class="ri-arrow-right-s-line"></i></span>
            <span class="breadcrumb-item" aria-current="page">
              <a routerLink="/invoice?-detail">Invoice Detail</a>
            </span>
          </div>

          <div class="card">
            <div class="card-body">
              <div class="pane-header">
                <h4 class="mt-2 mb-4">Invoice Details</h4>
              </div>
              <ng-container *ngIf="loading">
                <div class="text-center">
                  <app-loader></app-loader>
                </div>
              </ng-container>
              <ng-container *ngIf="!loading">
                <div class="row">
                  <div class="col-md-5">
                    <div class="detials-pane invoice?">
                      <div class="row">
                        <div class="col-12">
                          <div *ngIf="invoice?.barcode !== null" class="invoice?-item mb-2 row">
                            <div class="col-5">
                              <h6>Barcode</h6>
                            </div>
                            <div class="col-7 mt-2">
                              {{ invoice?.barcode }}
                            </div>
                          </div>
                          <div *ngIf="invoice?.irn !== null" class="invoice?-item mb-2 row">
                            <div class="col-5">
                              <h6>IRN</h6>
                            </div>
                            <div class="col-7">
                              {{ invoice?.docDetail.irn }}
                            </div>
                          </div>
                          <!-- <div class="invoice?-item mb-4 row">
                        <div class="col-5"><h6>PO NO.</h6></div>
                        <div class="col-7">
                          {{ invoice?.reference_details.items[0].poNo }}
                        </div>
                      </div> -->
                          <div class="invoice?-item mb-2 row">
                            <div class="col-5">
                              <h6>Invoice No.</h6>
                            </div>
                            <div class="col-7">
                              <p class="txt-adjust">
                                {{ invoice?.docNo }}
                              </p>
                            </div>
                          </div>

                          <div class="invoice?-item mb-2 row">
                            <div class="col-5">
                              <h6>Invoice Amount</h6>
                            </div>
                            <div class="col-7">
                              <p class="txt-adjust">
                                {{ invoice?.docAmt | inrdisplay }}
                              </p>
                            </div>
                          </div>

                          <div class="invoice?-item mb-2 row">
                            <div class="col-5">
                              <h6>Invoice Date</h6>
                            </div>
                            <div class="col-7">
                              <p class="txt-adjust">
                                {{ invoice?.docDate | date : "dd/MM/yyyy" }}
                              </p>
                            </div>
                          </div>

                          <div class="invoice?-item mb-2 row" *ngIf="invoice?.invoice_due_date !== ''">
                            <div class="col-5">
                              <h6>Invoice Due Date</h6>
                            </div>
                            <div class="col-7">
                              <p class="txt-adjust">
                                {{ invoice?.dueDate | date : "dd/MM/yyyy" }}
                              </p>
                            </div>
                          </div>

                          <div class="invoice?-item mb-2 row">
                            <div class="col-5">
                              <h6>Tax Registration Number</h6>
                            </div>
                            <div class="col-7">
                              <p class="txt-adjust">
                                {{ invoice?.docDetail.docGstin }}
                              </p>
                            </div>
                          </div>

                          <div class="invoice?-item mb-2 row">
                            <div class="col-5">
                              <h6>Invoice URL</h6>
                            </div>
                            <div class="col-7">
                              <p class="txt-adjust">
                                <a target="_blank" href="{{ invoice?.file_link }}" rel="noopener"> View PDF </a>
                              </p>
                            </div>
                          </div>

                          <div class="invoice?-item mb-2 row">
                            <div class="col-5">
                              <h6>Purchase Organisation</h6>
                            </div>
                            <div class="col-7">
                              <p class="txt-adjust">
                                {{ invoice?.purchaseOrgName }}
                              </p>
                            </div>
                          </div>

                          <div class="invoice?-item mb-2 row" *ngIf="postedStatus">
                            <div class="col-5">
                              <h6>Payment Due Date</h6>
                            </div>
                            <div class="col-7">
                              <p *ngIf="postedStatus?.meta?.payment_due_date !== null" class="txt-adjust">
                                {{ postedStatus?.meta?.payment_due_date }}
                              </p>
                              <p *ngIf="invoice?.payment_due_date === null" class="txt-adjust blur">Not Available</p>
                            </div>
                          </div>

                          <div class="invoice?-item mb-2 row" *ngIf="!postedStatus">
                            <div class="col-5">
                              <h6>Payment Due Date</h6>
                            </div>
                            <div class="col-7">
                              <p class="txt-adjust blur">Not Available</p>
                            </div>
                          </div>

                          <div class="invoice?-item mb-2 row" *ngIf="invoice?.paymentAdviceLink">
                            <div class="col-5">
                              <h6>Payment Advice</h6>
                            </div>
                            <div class="col-7">
                              <p class="txt-adjust">
                                <a target="_blank" href="{{ invoice?.paymentAdviceLink }}" rel="noopener"> View PDF </a>
                              </p>
                            </div>
                          </div>

                          <div class="invoice?-item mb-2 row" *ngIf="!invoice?.paymentAdviceLink">
                            <div class="col-5">
                              <h6>Payment Advice</h6>
                            </div>
                            <div class="col-7">
                              <p class="txt-adjust blur">Will be available once Invoice is Paid</p>
                            </div>
                          </div>

                          <div class="invoice?-item mb-2 row" *ngIf="paidStatus">
                            <div class="col-5">
                              <h6>UTR Number</h6>
                            </div>
                            <div class="col-7">
                              <p class="txt-adjust">
                                {{ paidStatus?.meta?.utr_number }}
                              </p>
                            </div>
                          </div>
                          <div class="invoice?-item mb-2 row" *ngIf="!paidStatus">
                            <div class="col-5">
                              <h6>UTR Number</h6>
                            </div>
                            <div class="col-7">
                              <p class="txt-adjust blur">Will be available once Invoice is Paid</p>
                            </div>
                          </div>

                          <div class="invoice?-item mb-2 row" *ngIf="paidStatus">
                            <div class="col-5">
                              <h6>Payment Date</h6>
                            </div>
                            <div class="col-7">
                              <p class="txt-adjust">
                                {{ paidStatus?.meta?.payment_date }}
                              </p>
                            </div>
                          </div>

                          <div class="invoice?-item mb-2 row" *ngIf="!paidStatus">
                            <div class="col-5">
                              <h6>Payment Date</h6>
                            </div>
                            <div class="col-7">
                              <p class="txt-adjust blur">Will be available once Invoice is Paid</p>
                            </div>
                          </div>

                          <div class="invoice?-item mb-2 row" *ngIf="invoice?.debit_note_attachment">
                            <div class="col-5">
                              <h6>Debit Note</h6>
                            </div>
                            <div class="col-7">
                              <p *ngIf="debitNoteExist" class="txt-adjust">
                                <a target="_blank" href="{{ invoice?.debit_note_attachment }}" rel="noopener"> View PDF </a>
                              </p>
                            </div>
                          </div>

                          <div class="invoice?-item mb-2 row" *ngIf="!debitNoteExist">
                            <div class="col-5">
                              <h6>Debit Note</h6>
                            </div>
                            <div class="col-7">
                              <p class="txt-adjust blur">If Applicable</p>
                            </div>
                          </div>

                          <div class="invoice?-item mb-2 row">
                            <div class="col-5">
                              <h6>GST Reconciled?</h6>
                            </div>
                            <div class="col-7">
                              <ng-container *ngIf="invoice?.gst_exist">
                                <p class="txt-adjust" *ngIf="invoice?.gst_reconciled === 'TRUE'">Yes</p>
                                <p class="txt-adjust" *ngIf="invoice?.gst_reconciled === 'FALSE'">Not Available</p>
                                <p class="txt-adjust" *ngIf="invoice?.gst_reconciled === 'UNKNOWN'">Not Available</p>
                              </ng-container>

                              <ng-container *ngIf="!invoice?.gst_exist">
                                <p class="txt-adjust">Not Available</p>
                              </ng-container>
                            </div>
                          </div>

                          <ng-container *ngIf="invoice?.docType === 'PO2S - PO2S'">
                            <div class="invoice?-item mb-2 row" *ngFor="let vessel of invoice?.docInfo">
                              <div class="col-5">
                                <h6 *ngIf="vessel.key === 'vesselName'">Vessel Name</h6>
                                <h6 *ngIf="vessel.key === 'vesselNumber'">Vessel Number</h6>
                              </div>
                              <div class="col-7">
                                <p class="txt-adjust">
                                  {{ vessel.value }}
                                </p>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <h5 class="pb-4 status-pane-header">
                      Invoice Status History
                      <span (click)="statusInfo()"><i class="ri-information-fill"></i></span>
                    </h5>
                    <div class="status-pane">
                      <ng-container *ngIf="invoice?.gpStatus.statusHistory.length !== 0">
                        <table aria-describedby="invoice?-status" class="table mb-0 table-striped toggle-arrow-tiny tablet breakpoint text-left invoice?-status">
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>Status</th>
                              <th>Owner</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let status of invoice?.gpStatus.statusHistory">
                                                           <ng-container *ngIf="status.timestamp !== ''" >
                                <td [ngClass]="[status.timestamp !== '' ? 'default' : 'text-shade', status.status === 'REJECTED' || status.status === 'Rejected' ? 'rejected' : 'normal']">
                                  {{ status.timestamp }}
                                </td>
                                <td [ngClass]="[status.timestamp !== '' ? 'default' : 'text-shade', status.status === 'REJECTED' || status.status === 'Rejected' ? 'rejected' : 'normal']">
                                  {{ status.meta.invoice_status }}
                                </td>
                                <td [ngClass]="status.timestamp !== '' ? 'default' : 'text-shade'">
                                  <ng-container *ngIf="status.status === 'Pending_submission'">Vendor</ng-container>
                                  <ng-container *ngIf="status.status === 'SUBMITTED'">Vendor</ng-container>
                                  <ng-container *ngIf="status.status === 'ACCEPTED'">Plant</ng-container>
                                  <ng-container *ngIf="status.status === 'APPROVED'">Plant</ng-container>
                                  <ng-container *ngIf="status.status === 'IN_PROCESSING'">GBS</ng-container>
                                  <ng-container *ngIf="status.status === 'IN_QUERY'">JSW User</ng-container>
                                  <ng-container *ngIf="status.status === 'POSTED'">GBS</ng-container>
                                  <ng-container *ngIf="status.status === 'CLEARED'">GBS</ng-container>

                                  <ng-container *ngIf="status.status === 'PAID'">GBS</ng-container>
                                  <ng-container [ngClass]="status.status === 'REJECTED' ? 'rejected' : 'normal'" *ngIf="status.status === 'REJECTED'">GBS</ng-container>

                                  <ng-container *ngIf="status.status === 'PENDING_SHIPPING_APPROVAL'">Vendor Portal</ng-container>

                                  <ng-container *ngIf="status.status === 'PENDING_VESON_APPROVAL'">Shipping Team</ng-container>
                                </td>
                                <td>
                                  <i *ngIf="status.status !== 'REJECTED'" [ngClass]="status.timestamp !== '' ? 'invoice-status checked' : 'default'" class="ri-checkbox-circle-fill"> </i>
                                  <i *ngIf="status.status === 'REJECTED'" [ngClass]="status.timestamp !== '' ? 'invoice-status checked rejected' : 'default'" class="ri-close-circle-fill"></i>
                                </td>
                              </ng-container>
                            </tr>
                            <tr *ngFor="let status of invoice?.statuses">
                              <ng-container *ngIf="status.timestamp !== '' && status.status === 'Cleared' && status.payment_adjusted === 'TRUE'">
                                <td>
                                  {{ status.timestamp }}
                                </td>

                                <td>
                                  <span class="adjust-text"> Payment Adjusted</span>
                                  <span>
                                    <i
                                      class="ri-information-fill"
                                      data-toggle="tooltip"
                                      data-placement="bottom"
                                      title="This Invoice has been cleared against an open debit. Check Payment Advice for further details"
                                    ></i
                                  ></span>
                                </td>
                                <td>GBS</td>
                                <td>
                                  <i class="checked ri-checkbox-circle-fill"> </i>
                                </td>
                              </ng-container>
                            </tr>
                          </tbody>
                        </table>
                      </ng-container>
                      <div *ngIf="invoice?.gpStatus?.statusHistory.length == 0">
                        <table aria-describedby="invoice?-status" class="table mb-0 table-striped toggle-arrow-tiny tablet breakpoint text-left invoice?-status">
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>Status</th>
                              <th>Owner</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <ng-container *ngIf="invoice?.gpStatus.currStatus.timestamp !== ''">
                                <td [ngClass]="[invoice?.gpStatus.currStatus.timestamp !== '' ? 'default' : 'text-shade', invoice?.gpStatus.currStatus.status === 'Rejected' ? 'rejected' : 'normal']">
                                  {{ invoice?.gpStatus.currStatus.timestamp }}
                                </td>
                                <td [ngClass]="[invoice?.gpStatus.currStatus.timestamp !== '' ? 'default' : 'text-shade', invoice?.gpStatus.currStatus.status === 'Rejected' ? 'rejected' : 'normal']">
                                  Pending Submission
                                </td>
                                <td [ngClass]="invoice?.gpStatus.currStatus.timestamp !== '' ? 'default' : 'text-shade'">
                                  <ng-container *ngIf="invoice?.gpStatus.currStatus.status === 'PENDING_SUBMISSION'">Vendor</ng-container>
                                  <ng-container *ngIf="invoice?.gpStatus.currStatus.status === 'SUBMITTED'">Vendor</ng-container>
                                  <ng-container *ngIf="invoice?.gpStatus.currStatus.status === 'ACCEPTED'">Plant</ng-container>
                                  <ng-container *ngIf="invoice?.gpStatus.currStatus.status === 'APPROVED'">Plant</ng-container>
                                  <ng-container *ngIf="invoice?.gpStatus.currStatus.status === 'IN_PROCESSING'">GBS</ng-container>
                                  <ng-container *ngIf="invoice?.gpStatus.currStatus.status === 'IN_QUERY'">JSW User</ng-container>
                                  <ng-container *ngIf="invoice?.gpStatus.currStatus.status === 'POSTED'">GBS</ng-container>
                                  <ng-container *ngIf="invoice?.gpStatus.currStatus.status === 'CLEARED'">GBS</ng-container>

                                  <ng-container *ngIf="invoice?.gpStatus.currStatus.status === 'PAID'">GBS</ng-container>
                                  <ng-container [ngClass]="invoice?.gpStatus.currStatus.status === 'REJECTED' ? 'rejected' : 'normal'" *ngIf="invoice?.gpStatus.currStatus.status === 'REJECTED'"
                                    >GBS</ng-container
                                  >

                                  <ng-container *ngIf="invoice?.gpStatus.currStatus.status === 'PENDING_SHIPPING_APPROVAL'">Vendor Portal</ng-container>

                                  <ng-container *ngIf="invoice?.gpStatus.currStatus.status === 'PENDING_VESON_APPROVAL'">Shipping Team</ng-container>
                                </td>
                                <td>
                                  <i
                                    *ngIf="invoice?.gpStatus.currStatus.status !== 'Rejected'"
                                    [ngClass]="invoice?.gpStatus.currStatus.timestamp !== '' ? 'checked' : 'default'"
                                    class="ri-checkbox-circle-fill"
                                  >
                                  </i>
                                  <i
                                    *ngIf="invoice?.gpStatus.currStatus.status === 'Rejected'"
                                    [ngClass]="invoice?.gpStatus.currStatus.timestamp !== '' ? 'checked rejected' : 'default'"
                                    class="ri-checkbox-circle-fill"
                                  >
                                  </i>
                                </td>
                              </ng-container>
                            </tr>
                            <tr *ngFor="let status of invoice?.statuses">
                              <ng-container *ngIf="status.timestamp !== '' && status.status === 'Cleared' && status.payment_adjusted === 'TRUE'">
                                <td>
                                  {{ status.timestamp }}
                                </td>

                                <td>
                                  <span class="adjust-text"> Payment Adjusted</span>
                                  <span>
                                    <i
                                      class="ri-information-fill"
                                      data-toggle="tooltip"
                                      data-placement="bottom"
                                      title="This Invoice has been cleared against an open debit. Check Payment Advice for further details"
                                    ></i
                                  ></span>
                                </td>
                                <td>GBS</td>
                                <td>
                                  <i class="checked ri-checkbox-circle-fill"> </i>
                                </td>
                              </ng-container>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

          <div class="loader-wrapper" *ngIf="showing">
            <div class="loader-content status-sequence">
              <div class="loader-text text-center my-3">
                <h4>Invoice Status Sequence</h4>
              </div>
              <div class="loader-body">
                <div class="container">
                  <!-- <div class="text-brief text-center mb-3">
                                        All statuses as displayed on the UI
                                        today with their owner and explanations
                                    </div> -->
                  <table aria-describedby="invoice?-status" class="table mb-0 table-striped toggle-arrow-tiny tablet breakpoint text-left">
                    <thead>
                      <tr>
                        <th class="text-left">Status</th>
                        <th class="text-left">Owner</th>
                        <th class="text-left">Brief</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Pending Submission</td>
                        <td>Vendor</td>
                        <td>The invoice? has been successfully uploaded but not yet submitted.</td>
                      </tr>
                      <tr>
                        <td>Submitted</td>
                        <td>Vendor</td>
                        <td>The invoice? has been submitted and sent to JSW.</td>
                      </tr>
                      <tr>
                        <td>Accepted</td>
                        <td>Plant</td>
                        <td>The invoice? has been accepted by JSW.</td>
                      </tr>
                      <tr>
                        <td>Approved</td>
                        <td>Plant</td>
                        <td>The invoice? has been approved by user department for further processing.</td>
                      </tr>
                      <tr>
                        <td>In Processing</td>
                        <td>GBS</td>
                        <td>The invoice? is in processing with GBS.</td>
                      </tr>
                      <tr>
                        <td>In Query</td>
                        <td>JSW User</td>
                        <td>There could be an issue with your Invoice. Reach out to the JSW support desk if you have not received any related communication.</td>
                      </tr>
                      <tr>
                        <td>Posted</td>
                        <td>GBS</td>
                        <td>The invoice? has been processed and sent to Audit for final review.</td>
                      </tr>
                      <tr>
                        <td>Cleared</td>
                        <td>GBS</td>
                        <td>Invoice cleared for payment.</td>
                      </tr>
                      <tr>
                        <td>Paid</td>
                        <td>GBS</td>
                        <td>Invoice paid and funds transferred to vendor’s account.</td>
                      </tr>

                      <tr>
                        <td>Rejected</td>
                        <td>GBS</td>
                        <td>The invoice has been rejected. Reach out to the JSW support desk if you have not received any related communication.</td>
                      </tr>
                      <!-- <tr>
                                        <td>Payment 
                                            Adjusted</td>
                                        <td>GBS</td>
                                        <td>
                                            Payment of invoice? adjusted
                                        </td>
                                    </tr> -->
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="loader-footer text-center my-3">
                <button class="btn btn-default" (click)="closeStatusInfo()">OK</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
